var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var ShapeWrapperInteractionView = require("./../../shapeWrapperViewer/shapeWrapperInteractionView.js");

var SilkscreenInteractionView = function (editorView, interactionModel, parentGroup, layers) {
     ShapeWrapperInteractionView.apply(this, arguments);
};
lib_core.inherit(SilkscreenInteractionView, ShapeWrapperInteractionView);

module.exports = SilkscreenInteractionView;

SilkscreenInteractionView.prototype.getLayers = function () {
    //Don't like checking for footprintlayers.TOP and also for 0...
    if(this.data.layerIndex.contains(0) &&
        (this.editorModel.visibleLayers.contains(0) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.TOP))) {
        console.assert(this.layers.silkscreenTop && this.layers.silkscreenTopControl, "Missing layers");

        return {
            draw: this.layers.silkscreenTop,
            control: this.layers.silkscreenTopControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(this.data.layerIndex.contains(1) &&
        (this.editorModel.visibleLayers.contains(1) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.BOTTOM))){
        console.assert(this.layers.silkscreenBottom && this.layers.silkscreenBottomControl, "Missing layers");

        return {
            draw: this.layers.silkscreenBottom,
            control: this.layers.silkscreenBottomControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
}